var React = require('react');

function ArrowDownWide (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.56775 1.85254L15.4258 13.8525L29.2839 1.85254","strokeWidth":"4"}));
}

ArrowDownWide.defaultProps = {"width":"31","height":"17","viewBox":"0 0 31 17","fill":"none"};

module.exports = ArrowDownWide;

ArrowDownWide.default = ArrowDownWide;
